import React from 'react';
import { createUseStyles } from 'react-jss';
import { Checkbox } from '@mui/material';
import { OTHER_PREFERENCE } from '../../../../utils/constant';

interface PaymentPreferenceViewTemplateProps {
    payments: string;
    creditDays: string;
    itemCheckbox: number[];
}

const useStyles = createUseStyles((theme: any) => ({
    title: {
        color: theme.palette.text.primaryLight
    },
    values: {
        color: theme.palette.text.primaryLight
    },
    otherPref: {
        color: theme.palette.text.primaryLight
    },
    numberedListItem: {
        fontSize: '1rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
    checkBox: {
        "& .MuiSvgIcon-root": {
            color:  theme.palette.buttonV2.secondaryText.text.primaryLight,
        },
        "&.MuiButtonBase-root.MuiCheckbox-root":{
            padding: "0px"
        }
    },
    border: {
        borderBottom: `1px solid ${theme.palette.textV2.tertiary.tertiary100}`
    }
}));

const PaymentPreferenceViewTemplate: React.FC<PaymentPreferenceViewTemplateProps> = ({ payments, creditDays, itemCheckbox }) => {
    const classes = useStyles();
    return (
        <>
           <div className={classes.border}>
                <div className="flex gap-x-6 mt-6 mb-20">
                    <div className="w-1/3">
                        <div className={`${classes.title} text-sm font-normal`}>Payment Preference</div>
                        <div className={`${classes.values} text-base font-medium`}>{payments}</div>
                    </div>
                    <div className="w-full">
                        <div className={`${classes.title} text-sm font-normal`}>Credit Period Days</div>
                        <div className={`${classes.values} text-base font-medium`}>{creditDays}</div>
                    </div>
                </div>
            </div>
            <div className={classes.border}>
                <div className={`${classes.otherPref} text-2xl my-6 font-medium`}>Other Preferences</div>
            </div>
            <div className="w-full">
                <div>
                    {OTHER_PREFERENCE.filter(pref => itemCheckbox.includes(pref.id)).map((pref, index) => (
                        <div key={pref.id}>
                            <div  className='flex items-center my-6'>
                            <Checkbox checked disabled className={`${classes.checkBox}`} /> <span className={`${classes.otherPref}  text-base font-medium ml-6`}>{pref.value}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PaymentPreferenceViewTemplate;
